<template>
  <div>
    <!--SEARCH-->
    <SearchAndResult />
    <!--HISTORY-->
    <h4>
      <span>
        <vlt-icon class="Vlt-black Vlt-margin--bottom1" icon="history"/>
      </span>&nbsp;
      {{$t('message.dashboard.past_calls')}}
    </h4>
    <hr class="hr--short">
    <div class="Vlt-grid flexContainer">
        <div class="Vlt-col--2of4 Vlt-col--M-3of3 ">
          <vlt-table
            v-if="!loading"
            :columns="columns"
            :rows="historyData"
            :pagination="historyData.length > pageSize"
            :pageSize="pageSize"
            :emptyMessage="$t('message.dashboard.no_records')"
          >
            <template slot="item" slot-scope="slotProps">
              <td >{{ formatDate(slotProps.item.created) }}</td>
              <td >{{ convertSecsToFullTime(slotProps.item.duration) || '' }}</td>
              <td >{{ slotProps.item.feedNumber || 'N/A' }}</td>
              <td >{{ slotProps.item.feedDescription || 'N/A' }}</td>
            </template>
          </vlt-table>
        </div>
      </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations  } from 'vuex';
import SearchAndResult from 'Components/common/SearchAndResult';
import {
  VltIcon,
  VltTable,
} from '@vonagevolta/vue';

import {
  GET_USER_HISTORY,
} from 'Store/action-types';

export default {
  name: 'SearchNumberAndHistory',
  components: {
      VltIcon,
      VltTable,
      SearchAndResult,
  },
  directives: {
    focus: {
      inserted: function (el) {
        el.focus()
      }
    }
  },
  props: {},
  data() {
    return {
      processing: false,
      term: '',
      validatedNumber: '',
      errorNumberFormat: '',
      termError: null,
      columns: [
          { title: 'Date', property: 'date', sortable: true },
          { title: 'Duration', property: 'duration', sortable: false },
          { title: 'Stream', property: 'to', sortable: true },
          { title: 'Description', property: 'feedDescription', sortable: true },
      ],
      pageSize: 10,
      noFoundNumber: null,
      editCell: '',
      initEditValue: '',
      editing: false,
      newNumber: '',
      isConnecting: false,
      autoJoin: false,
      numberFromNoSearchRes: '',
      captionersForCurrentBridge: [],
    };
  },
  computed: {
    ...mapGetters({
      isAdmin: 'isAdmin',
      historyData: 'getHistory',
      loading: 'getLoading',
    }),
  },
  watch: {
    loading(current) {
        // console.log('current LOADING: ', current)
    },
    historyData: {
      immediate: true,
      handler(newProp) {
        // console.log('=========== Fetched history: ', newProp);
      },
    },
  },
  methods: {
    setCaptioners() {
      if (this.searchedBridge && this.searchedBridge.bridge && this.searchedBridge.bridge.userCallInfo) {
        this.captionersForCurrentBridge = [];
        this.searchedBridge.bridge.userCallInfo.forEach(
          (el) => {
              this.captionersForCurrentBridge.push( {number: el.userNumber, name: el.name })
          }
        );
      }
    },
    convertSecsToFullTime(secs) {
        if (!secs) {
          return '00:00:00';
        }
        let totalSeconds;
        try {
            totalSeconds = parseInt(secs);
        } catch (e) {
          console.error(e);
          return;
        }
        let hours = Math.floor(totalSeconds / 3600);
        totalSeconds %= 3600;
        let minutes = Math.floor(totalSeconds / 60);
        let seconds = totalSeconds % 60;

        minutes = String(minutes).padStart(2, "0");
        hours = String(hours).padStart(2, "0");
        seconds = String(seconds).padStart(2, "0");

        return `${hours}:${minutes}:${seconds}`;
    },
    ...mapActions({
        fetchHistory:  `${GET_USER_HISTORY}`,
    }),
    init() {
      let id = setInterval(() =>{
        if (!this.loading) {
          clearInterval(id);
          this.fetchHistory();
        }
      },2000);

    },
    formatDate(date) {
      // console.log('1 INIT DATE: ', date); //2020-07-24T07:54:22.272428Z // 2020-04-01T20:47:59.000+0000
      let newDate;
      let toLocalStr;

      if (!date) {
          return '';
      }

        const date2 = date.split('+');
        if (date2 && date2.length < 2) {
            newDate = new Date(date);
            toLocalStr = newDate.toLocaleString();
        } else if (date2 && date2.length === 2) {
            const tZ = date2[1];
            const sub1 = tZ.substring(0,2);
            const sub2 = tZ.substring(2);
            const tzF = `${sub1}:${sub2}`;
            const fDate = `${date2[0]}+${tzF}`;
            // console.log('2 ADAPTED DATE: ', fDate);
            newDate = new Date(fDate);
            // console.log('3 new Date(date) DATE: ', newDate);
            toLocalStr = newDate.toLocaleString();
            // console.log('4 toLocalStr DATE: ', toLocalStr);
        }
        return toLocalStr;
    },
  },
  created() {
    this.init();
  },
};
</script>

<style scoped lang="scss">
  .paddingRight20 {
    padding-right: 20px;
  }

  .paddingLeft20 {
    padding-left: 28px;
  }

  .flexContainer {
    display: flex;
    align-items: stretch;
    //justify-content: space-between;
  }

  .appBoxWidth {
    width: 380px;
  }

  .stretch-height {
    height: 100%;
  }

  .width100percent {
    width: 100%;
  }

  .Vlt-btn--uppercase {
    text-transform: uppercase;
  }

  .previewContent {
    height: 240px;
    max-height: 240px;
    display: flex;
    flex-direction: column;
  }
  .previewTextContent {
    flex: 1 0 auto;
    overflow: auto;
    max-height: 188px;
    .previewText {
      max-height: 80px;
      overflow: auto;
    }
  }
  .fixed-result-container {
    height: 350px;
  }
  .fixed-result-container2 {
    height: 250px;
  }
  .Vlt-badge-group .Vlt-badge.Vlt-badge--large {

  }
</style>
